<template>
    <div :class="navigateButtons && 'p-ai-center p-grid p-jc-center'">
        <div
                :class="navigateButtons && 'p-col'"
        >
            <div :class="navigateButtons && 'p-inputgroup'">
                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'הכיתה הקודמת'"
                        @click="navigateGrades(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>
<!--                :optionDisabled="'disabled'"-->

                <Dropdown
                        v-on="listeners"
                        style="text-align: center"
                        filterPlaceholder=" חפש לפי כיתה"
                        emptyFilterMessage=" לא נמצא שם כיתה תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="value"
                        :options="getGrades"
                        placeholder="בחר כיתה"
                        data-key="id"
                        @change="onSelect"

                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.hebrewName }}</span>
                    </template>
                </Dropdown>

                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'הכיתה הבאה'"
                        @click="navigateGrades(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Vue from "vue";

export default {
    props: {
        storageName: {
            type: String,
            default: "default"
        },
        defaultFirst: {
            type: Boolean,
            default: false
        },
        navigateButtons: {
            type: Boolean,
            default: false
        },
        useStore: {
            type: Boolean,
            default: false
        },
        replaceOptions: {
            type: Array,
            default: null
        },
        specificOptions: {
            type: Array,
            default: null
        },
        value: null
    },
    name: "SelectGrade",

    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: event => {
                    this.$emit('input', event?.target?.value);
                }
            };
        },
        getGrades() {
            // if (Array.isArray(this.replaceOptions) && this.replaceOptions.length > 0) {
            //     console.log("++++")
            //     const replacedGrades = [...this.gradeOptions]
            //     this.replaceOptions.forEach((grade) => {
            //         const matchTeacherIndex = this.gradeOptions.findIndex((t) => t.id === grade.id)
            //         replacedGrades[matchTeacherIndex] = grade
            //     })
            //
            //     return replacedGrades
            // }
            if (this.specificOptions){
                const specificGrades = this.gradeOptions?.filter((grade) => {
                   return  this.specificOptions.includes(grade.id)
                })
                return specificGrades
            }
            return this.gradeOptions ?? []
        },
        ...mapState(["gradeOptions"]),
    },
    created() {
        if (this.useStore) {
            const restoreGrade = Vue.ls.get(`selectGrade_${this.storageName}`)

            if (restoreGrade && this.gradeOptions.some(g => g.id === restoreGrade.id)){
                this.onSelect({originalEvent: null, value: restoreGrade})
            } else {
                if (this.defaultFirst){
                this.onSelect({originalEvent: null, value: this.getGrades[0]})
                }
            }
        }  else {
            if (this.defaultFirst){
                this.onSelect({originalEvent: null, value: this.getGrades[0]})
            }
        }
    },
    methods: {
        navigateGrades(isAdd) {
            const index = this.gradeOptions.findIndex(
                (grade) => grade.id === this.value?.id
            );
            const z =
                this.gradeOptions[
                ((isAdd ? index + 1 : index - 1) + this.gradeOptions.length) %
                this.gradeOptions.length
                    ];
            this.onSelect({originalEvent: null, value: z})
        },
        onSelect({originalEvent, value}) {
            Vue.ls.set(`selectGrade_${this.storageName}`, value)

            this.$emit('input', value);
            // this.$emit('change', {originalEvent: event, value: value});
            // this.value = this.selectedGrade
            this.$emit('onSelect', value);
        }
    },
}
</script>

<style scoped>

</style>